<template>
  <div>
    <!-- <van-image :src="classDetial.coverPictureUrl" /> -->
    <img :src="classDetial.coverPictureUrl" />
    <Title :classDetial="classDetial" />
    <ClassTabs :classDetial="classDetial" style="padding-bottom:70px" />
    <Footer class="Footer" :classDetial="classDetial" />
    <Gohome />
  </div>
</template>

<script>
import Title from "@/components/class/title";
import ClassTabs from "@/components/class/classTabs";
import Footer from "@/components/class/footer";
export default {
  components: {
    Title,
    Footer,
    ClassTabs,
  },
  data() {
    return {
      classDetial: {
        cname: "",
        vurl:"",
      },
    };
  },
  created() {
    this.getclassDetials();
  },
  methods: {
    getclassDetials() {
      let data = {
        cid: this.$route.query.cid,
      };
      this.Api({
        url: "api/course/getCourseDetails",
        method: "POST",
        data,
      }).then((res) => {
        this.classDetial = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.Footer {
  position: fixed;
  bottom: -3px;
  width: 100%;
}
</style>
